import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.fill.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import classes from '@nerdwallet/base-styles/classes';
import { colors as baseStylesColors } from '@nerdwallet/base-styles/variables';
import styles from './LoadingSpinner.module.less';
var PRESET_COLORS = {
  green: {
    background: 'green-lighter',
    fill: 'green'
  },
  'green-light': {
    background: 'green-lightest',
    fill: 'green-lighter'
  }
};
export var SPINNER_COLORS = Object.keys(PRESET_COLORS);
export var ROLES = ['progressbar', 'status'];

var getStrokeColors = function getStrokeColors(color) {
  var _PRESET_COLORS$color = PRESET_COLORS[color],
      background = _PRESET_COLORS$color.background,
      fill = _PRESET_COLORS$color.fill;
  return {
    background: baseStylesColors[background],
    fill: baseStylesColors[fill]
  };
};

export var LoadingSpinner = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'green' : _ref$color,
      inline = _ref.inline,
      _ref$loadingMessage = _ref.loadingMessage,
      loadingMessage = _ref$loadingMessage === void 0 ? 'Loading' : _ref$loadingMessage,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'progressbar' : _ref$role,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      strokeWidthProp = _ref.strokeWidth,
      otherProps = _objectWithoutProperties(_ref, ["color", "inline", "loadingMessage", "role", "size", "strokeWidth"]);

  // This is constant and manually calibrated with the stroke-dasharray and
  // stroke-dashoffset rules in the css.
  var viewBoxSize = 42; // Center of the circle is the center of the viewBox.

  var center = viewBoxSize / 2; // This is derived from the fast that at a size of 24px, we want a stroke
  // width of 4px, and at 64px, we want a stroke width of 8px. Solving for
  // the equation of the line between those two points gives you this. Note
  // that the strokeWidth prop can be used to override this if automatic
  // scaling is not desired for a particular use case.

  var strokeWidth = strokeWidthProp || 0.1 * size + 1.6; // SVGs are scaled relative to their viewBox. To ensure that the rendered
  // stroke is as close to the desired strokeWidth as possible, the
  // strokeWidth is scaled relative to the viewBox size.

  var scaledStrokeWidth = strokeWidth * viewBoxSize / size; // The radius of the circle is half the width of the viewbox.

  var radius = viewBoxSize / 2; // The circular stroke is drawn at twice the calculated strokeWidth on
  // either side of the path along the radius. The part drawn outside the
  // radius is then clipped so that only the inset stroke remains visible.
  //
  // Clipping is done with an SVG clipPath definition referenced by ID. The
  // clipPath definition depends only on viewBox size. To prevent ID clashes
  // if the viewBox size ever changes, the clipPath will be identified by an
  // ID derived from the viewBox size.

  var _useState = useState("clip-circle-".concat(viewBoxSize)),
      _useState2 = _slicedToArray(_useState, 2),
      clipPathId = _useState2[0],
      setClipPathId = _useState2[1]; // Safari bugs out when there are multiple spinners on a page and one gets
  // removed; the removal of the clipPath definition affects other spinners on
  // the page. As a workaround, a unique ID is generated on the browser. This
  // only happens on the client after the initial render to avoid a
  // server/client hydration mismatch.


  useEffect(function () {
    return setClipPathId(function (oldClipPathId) {
      return "".concat(oldClipPathId, "-").concat(uuid());
    });
  }, []);
  var colors = getStrokeColors(color);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes({
      'display-inline-block': inline,
      'display-block': !inline
    }),
    ref: ref,
    role: role,
    style: {
      width: size,
      height: size
    }
  }, otherProps), /*#__PURE__*/React.createElement("span", {
    // The following will only be visible to screen readers.
    className: classes('screen-reader-only')
  }, loadingMessage), /*#__PURE__*/React.createElement("svg", {
    // Prevent the loading indicator from being announced by screen readers.
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize) // allow overflow so half pixels in a scaled viewbox don't get cut off
    ,
    style: {
      overflow: 'visible'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("circle", {
    cx: center,
    cy: center,
    r: radius
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: colors.background,
    cx: center,
    cy: center,
    r: radius,
    clipPath: "url(#".concat(clipPathId, ")"),
    strokeWidth: scaledStrokeWidth * 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: styles.pathFill,
    fill: "none",
    stroke: colors.fill,
    cx: center,
    cy: center,
    r: radius,
    clipPath: "url(#".concat(clipPathId, ")"),
    strokeWidth: scaledStrokeWidth * 2
  }))));
});
LoadingSpinner.displayName = 'LoadingSpinner';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');

  LoadingSpinner.propTypes = {
    /** The color scheme of the spinner. */
    color: PropTypes.oneOf(SPINNER_COLORS),

    /** Whether the spinner will render as a block-level or inline element. */
    inline: PropTypes.bool,

    /** Loading message to be read to the screen reader. */
    loadingMessage: PropTypes.string,

    /** Role of the spinner in the context it is used. */
    role: PropTypes.oneOf(ROLES),

    /** Size of the spinner in pixels. */
    size: PropTypes.number,

    /**
     * Width of the circular path in pixels. If not explicitly provided, this
     * value will be automatically computed based on the spinner size.
     */
    strokeWidth: PropTypes.number
  };
}